module.exports = __webpack_public_path__ + "assets/img/thumb-Amaze-Wholesale-2-Landing-Page.03adf35b.webp";